import * as yup from 'yup'
import { REQUIRED_FIELD } from 'constants/errors'

export const uploadDocsSchema = yup.object().shape({
  documents: yup.array().test('notEmpty', REQUIRED_FIELD, function () {
    return this.parent.documents?.length > 0 || this.parent.uploadedDocuments?.length > 0
  }),
})
